import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { createI18n } from "vue-i18n";
import { enhanceI18nWithRemote } from "@emcd-shared/translate-service";
import Cookies from "js-cookie";
function loadLocaleMessages() {
  const locales = require.context("./locales", false, /[a-z]+\.json$/i);
  const messages = {};
  locales.keys().forEach(l => {
    const code = l.slice(2).split(".")[0];
    messages[code] = require(`./locales/${code}.json`);
  });
  return messages;
}
const i18n = createI18n({
  legacy: false,
  // Используем Composition API и современные методы
  locale: Cookies.get("lang") || "en",
  fallbackLocale: "en",
  messages: loadLocaleMessages(),
  globalInjection: true,
  // Опционально: для глобальной регистрации $t
  silentTranslationWarn: true,
  // Подавляем предупреждения о переводе
  fallbackWarn: false,
  missingWarn: false
});
enhanceI18nWithRemote(i18n, {
  apiUrl: import.meta.env.VUE_APP_TRANSLATE_API_URL,
  apiKey: import.meta.env.VUE_APP_TRANSLATE_API_KEY,
  project: "explorer",
  refreshIntervalMs: import.meta.env.VUE_APP_TRANSLATE_UPDATE_INTERVAL_MS,
  localMessages: loadLocaleMessages()
});
export { i18n };